export const linkUnderlineClass =
  `relative not-last:after:content-[''] after:absolute after:left-0 after:bottom-0 
   after:h-[1px] after:w-0 after:bg-current after:opacity-50 after:transition-all after:duration-300 
   hover:after:w-full`;

export const titleStyle = 
  `font-light text-[30px] lg:text-[40px] leading-[40px] lg:leading-[50px]`

export const smallButtonStyle = 
  'py-[11px] px-[37px] text-[15px] lg:text-[18px] leading-[25px] lg:leading-[28px] font-light'

export const largeButtonStyle = 
  'py-[11px] px-[37px] lg:px-[47px] text-[15px] lg:text-[18px] leading-[25px] lg:leading-[28px] font-light'

export const filledButtonStyle = 
  `relative overflow-hidden bg-[#A58356] text-white cursor-pointer
   before:absolute before:inset-0 before:-translate-x-full before:bg-gradient-to-r 
   before:from-transparent before:via-white/40 before:to-transparent 
   before:skew-x-12 before:transition-transform before:duration-700
   hover:before:translate-x-full`;

export const fadedButtonStyle = 
  `relative overflow-hidden bg-[#808080]/20 text-white cursor-pointer
   before:absolute before:inset-0 before:-translate-x-full before:bg-gradient-to-r 
   before:from-transparent before:via-white/40 before:to-transparent 
   before:skew-x-12 before:transition-transform before:duration-700
   hover:before:translate-x-full`;

export const filledIconStyle =
  `bg-[#A58760] flex items-center justify-center rounded-full transition-all cursor-pointer
   duration-300 ease-in-out hover:scale-110 hover:shadow-lg hover:brightness-110 w-[40] h-[40]`

export const filledIconButtonStyle =
  `bg-[#A58760] flex items-center justify-center rounded-full transition-all cursor-pointer
   duration-300 ease-in-out hover:scale-110 hover:shadow-lg hover:brightness-110 w-[48] h-[48]`

export const fadedIconButtonStyle = 
  `rounded-full w-12 h-12 flex items-center justify-center border border-white/70 bg-white/45
   backdrop-blur-xl hover:bg-white/55 hover:border-white/85 shadow-md hover:scale-110 
   hover:brightness-110 transition-all duration-400`

export const disabledIconButtonStyle =
  `bg-[#f7f4ef] flex items-center justify-center rounded-full transition-all 
   duration-300 ease-in-out w-[48] h-[48]`

export const ctaArrowIconStyle = 
  `bg-[#f7f4ef] flex items-center justify-center rounded-full transition-all 
   duration-300 ease-in-out w-[40px] h-[40px] xl:w-[60] xl:h-[60]`

export const h1Style =
  `text-[35px] xl:text-[50px] font-extralight leading-[40px] xl:leading-[60px]` //max-w-[740px]

export const h2Style = 
  `text-[30px] xl:text-[40px] font-light leading-[33px] xl:leading-[50px]`

export const h3Style = 
  `font-light text-[25px] xl:text-[34px] leading-[33px] xl:leading-[44px]`

export const h4Style = 
  `text-[20px] xl:text-[24px] leading-[28px] xl:leading-[34px] font-normal`

export const h5Style =
  `text-[15px] xl:text-[20px] leading-[23px] xl:leading-[30px] font-light`

export const h6Style = 
  `font-normal xl:text-[16px] leading-[26px]`

export const paragraphStyle = 
  `font-normal text-[15px] lg:text-[18px] leading-[23px] lg:leading-[28px]`

export const tagStyle = 
  `font-normal text-[11px] sm:text-[13px] leading-[28px]`

export const filterLabelStyle =
 `font-normal text-[10px] leading-[14px]`

export const inputTextStyle = 
 `font-normal text-[14px] leading-[14px]`